import { render, staticRenderFns } from "./StatusBar.vue?vue&type=template&id=2bc3e867&"
import script from "./StatusBar.vue?vue&type=script&lang=js&"
export * from "./StatusBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bc3e867')) {
      api.createRecord('2bc3e867', component.options)
    } else {
      api.reload('2bc3e867', component.options)
    }
    module.hot.accept("./StatusBar.vue?vue&type=template&id=2bc3e867&", function () {
      api.rerender('2bc3e867', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/StatusBar.vue"
export default component.exports